import { createGlobalStyle } from 'styled-components';

import '@flaticon/flaticon-uicons/css/all/all.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';

export default createGlobalStyle`
  :root {
    --black: #000000;
    --white: #FFFFFF;

    --gray-0: #F7F7F7;
    --gray-1: #E0E0E0;
    --gray-2: #C2C2C2;
    --gray-3: #9E9E9E;
    --gray-4: #757575;
    --gray-5: #545454;
    --gray-6: #373737;
    --gray-7: #1F1F1F;
  }

  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    width: 100%;
    height: auto !important;
    min-height: 100%;
    overflow-x: hidden;
    line-height: 1;
    font-family: 'Roboto', sans-serif !important;
    font-size: 14px !important;
    color: var(--black) !important;
    background-color: var(--white);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul, ol {
    list-style: none;
  }

  button {
    cursor: pointer;
    border: none;
    background: none;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote::before,
  blockquote::after,
  q::before,
  q::after {
    content: "";
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  ::selection {
    background-color: #e3e3e3ff;
  }

  .container {
    padding: 0;
  }
`;
